import {
  GET_STUDENT_ATTENDANCE_LIST, GET_STUDENT_ATTENDANCE_LIST_NEXT, GET_STUDENT_ATTENDANCE_AVERAGE,
  GET_STUDENT_ATTENDANCE_SUMMARY_LIST
} from '../action-types'
import {
  SET_STUDENT_ATTENDANCE_LIST, APPEND_STUDENT_ATTENDANCE_LIST, SET_STUDENT_ATTENDANCE_AVERAGE,
  SET_STUDENT_ATTENDANCE_DATES, SET_STUDENT_ATTENDANCE_STUDENT,
  SET_STUDENT_ATTENDANCE_LIST_LOADING, SET_STUDENT_ATTENDANCE_SUMMARY_LIST, SOFT_RESET_ATTENDANCE_LIST
} from '../mutation-types'
import server from '../server'
import moment from 'moment-es6'

const state = {
  studentId: 0,
  loadingList: false,
  currentPage: -1,
  pageSize: 50,
  allLoaded: false,
  studentAttendance: [],
  studentAttendanceSummary: [],
  studentAttendanceAverage: 0,
  fromDate: moment().subtract(28, 'days').format('YYYY-MM-DD'),
  toDate: moment().subtract(1, 'days').format('YYYY-MM-DD')
}

const mutations = {
  [SET_STUDENT_ATTENDANCE_LIST] (state, list) {
    state.studentAttendance = list
  },
  [SET_STUDENT_ATTENDANCE_SUMMARY_LIST] (state, list) {
    state.studentAttendanceSummary = list
  },
  [APPEND_STUDENT_ATTENDANCE_LIST] (state, list) {
    state.studentAttendance.splice(state.studentAttendance.length, ...list)
  },
  [SET_STUDENT_ATTENDANCE_AVERAGE] (state, studentAttendanceAverage) {
    state.studentAttendanceAverage = studentAttendanceAverage
  },
  [SET_STUDENT_ATTENDANCE_DATES] (state, {fromDate, toDate}) {
    state.fromDate = fromDate
    state.toDate = toDate
  },
  [SET_STUDENT_ATTENDANCE_STUDENT] (state, studentId) {
    state.studentId = studentId
    state.studentAttendance = []
    state.currentPage = -1
    state.allLoaded = false
  },
  [SET_STUDENT_ATTENDANCE_LIST_LOADING] (state, {loading, currentPage, allLoaded}) {
    state.loadingList = loading
    if (loading) {
      state.currentPage = currentPage
      state.allLoaded = false
    } else {
      state.allLoaded = allLoaded
    }
  },
  [SOFT_RESET_ATTENDANCE_LIST] (state) {
    state.studentAttendance = []
  }

}

const getStudentAttendanceList = function (commit, state, pageNumber, commitName, actionData) {
  commit(SET_STUDENT_ATTENDANCE_LIST_LOADING, {loading: true, currentPage: pageNumber})
  server.postReplayable(`/core/student/${state.studentId}/attendance/filter`, {
    ascDesc: 'DESC',
    sortBy: 'EXPECTED_ATTENDANCE_DATE',
    pageNumber: pageNumber,
    pageSize: state.pageSize,
    fromDate: state.fromDate,
    toDate: state.toDate,
    studentId: state.studentId
  }, actionData).then(result => {
    commit(commitName, result.data.content)
    commit(SET_STUDENT_ATTENDANCE_LIST_LOADING, {loading: false, allLoaded: result.data.last})
  })
}

const actions = {
  [GET_STUDENT_ATTENDANCE_LIST] ({commit, state}) {
    const actionData = { action: GET_STUDENT_ATTENDANCE_LIST }
    commit(SOFT_RESET_ATTENDANCE_LIST)
    getStudentAttendanceList(commit, state, 0, SET_STUDENT_ATTENDANCE_LIST, actionData)
  },
  [GET_STUDENT_ATTENDANCE_LIST_NEXT] ({commit, state}) {
    const actionData = { action: GET_STUDENT_ATTENDANCE_LIST_NEXT }
    if (!state.allLoaded) {
      getStudentAttendanceList(commit, state, state.currentPage + 1, APPEND_STUDENT_ATTENDANCE_LIST, actionData)
    }
  },
  [GET_STUDENT_ATTENDANCE_AVERAGE] ({commit, state}) {
    const actionData = { action: GET_STUDENT_ATTENDANCE_AVERAGE }
    const url = `/core/student/${state.studentId}/attendance_percentage/${state.fromDate}/${state.toDate}`
    server.getReplayable(url, actionData).then(result => {
      commit(SET_STUDENT_ATTENDANCE_AVERAGE, result.data)
    })
  },
  [GET_STUDENT_ATTENDANCE_SUMMARY_LIST] ({commit, state}) {
    const actionData = { action: GET_STUDENT_ATTENDANCE_SUMMARY_LIST }
    const url = `/core/student/${state.studentId}/attendance/${state.fromDate}/${state.toDate}`
    server.getReplayable(url, actionData)
      .then(result => {
        commit(SET_STUDENT_ATTENDANCE_SUMMARY_LIST, result.data)
      })
      .catch(error => {
        console.error(error)
      })
  }
}

export default {
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/attendanceModule.js